import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis';
import axios from 'axios';



export const getInvoicesList = createAsyncThunk('getInvoicesList', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/invoice/invoice_list`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const markPaymentStatus = createAsyncThunk('markPaymentStatus', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/invoice/update_payment_status`
  try {
    const response = await axios.post(URL, data)
    return response
  } catch (error) {
    return handleErrorResponse(error, rejectWithValue)
  }
});

export const invoiceUploadFile = createAsyncThunk('invoiceUploadFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/invoice/update_file`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data?.file); 
    bodyFormData.append('upload_type', data?.upload_type); 
    bodyFormData.append('payment_id', data?.payment_id); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateInvoiceRemarks = createAsyncThunk('updateInvoiceRemarks', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/invoice/update_invoice_remarks`
  try {
    const response = await axios.post(URL, data)
    return response
  } catch (error) {
    return handleErrorResponse(error, rejectWithValue)
  }
});

// v1/erp/invoice/update_invoice_remarks